import bg from "assets/images/Motherhood.png"
import Button from "components/Button"
import SmallCard from "components/SmallCard"
import GD from 'assets/images/gd.svg'
import GL from 'assets/images/gl.svg'
import WT from 'assets/images/wt.svg'
import CAL from 'assets/images/cal.svg'
import BP from 'assets/images/bp.svg'
import Charts from "components/chart"
import Event from "components/Event"
import SVGs from "helpers/SVGs"
import { useEffect, useState, useRef } from "react"
import AddVital from "components/AddVital"
import AddAppointment from "components/AddAppointment"
import { getLatestVitals } from "services/patient/vitals"
import { getAppointments } from "services/patient/appointment"
import { useDispatch, useSelector } from "react-redux";
import { setBPVital, setWEVital,setGLVital, setGAVital, setCDVital, setEDDVital } from "store/slices/vitalSlice"
import { setAppointment } from "store/slices/appointmentSlice"
import { RootState } from "store";

const Metrics = () => {

    const dispatch = useDispatch();
    const user = useSelector((state:RootState )=> state.userData.user)
    const appointments = useSelector((state:RootState )=> state.appointmentData.appointments)
    const bpVital = useSelector((state:RootState )=> state.vitalData.bpVital)
    const weVital = useSelector((state:RootState )=> state.vitalData.weVital)
    const glVital = useSelector((state:RootState )=> state.vitalData.glVital)
    const gaVital = useSelector((state:RootState )=> state.vitalData.gaVital)
    const cdVital = useSelector((state:RootState )=> state.vitalData.cdVital)
    const eddVital = useSelector((state:RootState )=> state.vitalData.eddVital)
    
    const [ showCalendar, toggleCalendar ] = useState(true)
    const [ showVitalModal, toggleVitalModal ] = useState(false)
    const [ showAppointmentModal, toggleAppointmentModal ] = useState(false)

    const infomationArray = [
        "Having a good night sleep improves your health and that of the baby , talk to your healthcare provider if you are sleeping too short or not deep enough",
        "Your finances can affect your health outcomes please budget and plan ahead",
        "If you feel overwhelming sadness or suddenly feel you are finding difficulties coping talk to your doctor or midwife"
    ]

    const [ active, setActive ] = useState(infomationArray[0])

    useEffect(()=> {
        getLatestVitals().then(res => {
              for (const item of res.data.result) {
                const vital_type = item.vital_type
                switch(vital_type) {
                    case "BP":
                        dispatch(setBPVital(item))
                    break;
                    case "GL":
                        dispatch(setGLVital(item))
                    break;
                    case "WE":
                        dispatch(setWEVital(item))
                    break;
                    case "GE":
                        dispatch(setCDVital(new Date(item.first_day_of_last_circle).toLocaleDateString()))
                        dispatch(setGAVital(item.due_in_days))
                        dispatch(setEDDVital(new Date(item.due_date).toLocaleDateString()))
                    break;
                } 
          }
    } 
    )},[dispatch])

    useEffect(()=>{
        getAppointments().then(res => {
            dispatch(setAppointment(res.data.result))
        })
    },[dispatch])

    const bpRef = useRef(bpVital);
    const weRef = useRef(weVital);
    const glRef = useRef(glVital);
    const gaRef = useRef(gaVital);
    const cdRef = useRef(cdVital);
    const eddRef = useRef(eddVital);

    useEffect(() => {
      bpRef.current = bpVital;
    }, [bpVital]);

    useEffect(() => {
        weRef.current = weVital;
      }, [weVital]);
      
    useEffect(() => {
        glRef.current = glVital;  
      }, [glVital]);
      
    useEffect(() => {
        gaRef.current = gaVital;  
      }, [gaVital]);
      
    useEffect(() => {
        cdRef.current = cdVital; 
      }, [cdVital]);
      
    useEffect(() => {
        eddRef.current = eddVital;  
      }, [eddVital]);

    return(
        <div className="w-full flex relative" >
                <AddVital show={showVitalModal} toggleClose={()=>toggleVitalModal(!showVitalModal)} />
                <AddAppointment show={showAppointmentModal} toggleClose={()=>toggleAppointmentModal(!showAppointmentModal)} />
         
            <div  className={`w-full lg:w-2/3 p-10 ${showCalendar ? '' : 'lg:screen' }`}>
                <div className="flex justify-between" >
                    <div>
                        { /*  <h5>Hello {user.first_name.charAt(0).toUpperCase() + user.first_name.toLowerCase().slice(1)}</h5> */}
                        <h5 className="text-light_grey_text"> Afriyie App </h5>
                        <p className="text-light_grey_text" >Today is {new Date().toDateString()} </p>
                    </div>
                    <div className="flex flex-col justify-center" >
                        <p className=" text-secondary text-sm cursor-pointer mb-2" onClick={()=>toggleVitalModal(!showVitalModal)} >
                            + Add Vitals
                        </p>
                        <p className=" text-tertiary text-sm cursor-pointer" onClick={()=>toggleCalendar(!showCalendar)} >
                            {showCalendar? "hide calendar": "show Calendar"}
                        </p>

                    </div>
                </div>

                <div className="my-6" >
                    <div className="w-full h-fit lg:h-[220px] bg-primary rounded-xl p-4 flex overflow-hidden" >
                        <div  className=" p-6 py-2 w-fit min-w-21" >
                            <p className="text-xs text-[#80ABCD]" >
                                Reminder
                            </p>
                            <h3 className="text-[#ffffff] text-3xl" >
                            Have you gone for check-up recently?
                            </h3>
                            <p className=" pt-4 text-tertiary" >{active}</p>
                            {/* <div className="w-44 -mt-2" >
                                <Button secondary title="Check Activity" />

                            </div> */}
                        </div>
                        <div className=" relative flex gap-10 lg:h-[280px] overflow-hidden" >
                            <img src={bg} className=' -left-10 -top-12 h-56 md:h-72 lg:h-[400px] object-cover object-top'  alt=".." />
                        </div>
                    </div>

                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-6 w-full" >
                    <SmallCard name={bpVital.name} value={bpVital.value} unit={bpVital.unit} icon={BP} /> 
                    <SmallCard name={glVital.name} value={glVital.value} unit={glVital.unit} icon={GL} /> 
                    <SmallCard name={weVital.name} value={weVital.value} unit={weVital.unit} icon={WT} /> 
                    <SmallCard name={cdVital.name} value={cdVital.value} unit={cdVital.unit} icon={CAL} />
                    <SmallCard name={gaVital.name} value={gaVital.value} unit={gaVital.unit} icon={GD} />
                    <SmallCard name={eddVital.name} value={eddVital.value} unit={eddVital.unit} icon={CAL} />
                </div>

                <div className="w-full bg-[#fff] h-80 rounded-xl mt-6 py-4" >
                    <Charts />
                </div>

            </div>

            <div className={`lg:block lg:w-1/3 border-l bg-[#fff] py-6 px-10 ${showCalendar ? 'block absolute z-10 right-0 w-80 h-full lg:relative' : 'invisible' }`} >

                <div className="flex justify-between items-center" >
                    <h5 className="mt-4" >Calendar</h5>
                    <p className="lg:hidden cursor-pointer text-secondary" onClick={()=>toggleCalendar(!showCalendar)} >{SVGs.close}</p>
                </div>
                <div><p className=" text-secondary text-sm cursor-pointer my-4" onClick={()=>toggleAppointmentModal(!showAppointmentModal)} >
                            + Set reminder
                        </p>
                </div>
                <div>
                    {appointments.map((appointment)=>{
                       return <Event type="very important" time={new Date(appointment.appointment_start_date_time).toDateString()} agenda={appointment.event} key={appointment._id}/>
                    })}
                </div>
                
{/*               
s
                <p className="text-sm text-light_grey_text mt-12 mb-3" >August</p>
                <Event type="normal" time="" agenda="" />
               
                
                <p className="text-sm text-light_grey_text mt-12 mb-3" >September</p>
                <Event type="normal" time="" agenda="" />
              
                
                <p className="text-sm text-light_grey_text mt-12 mb-3" >October</p>
            
                <Event type="very important" time="" agenda="" />
                
                <p className="text-sm text-light_grey_text mt-12 mb-3" >November</p>
            
                <Event type="very important" time="" agenda="" />
                
                <p className="text-sm text-light_grey_text mt-12 mb-3" >December</p>
            
                <Event type="very important" time="" agenda="" /> */}


            </div>

        </div>
    )
}

export default Metrics
